import React from 'react';
import PropTypes from 'prop-types';

import './CircleAnnouncement.scss';

/**
 * CircleAnnouncement is used to display fullscreen announcements to the user.
 * It is a presentational component, and as such should be a sub-component of more specific modal components
 * such as <NotificationsCircleAnnouncement>
 */
CircleAnnouncement.propTypes = {
  
  /** Text to be displayed in modal header */
  headingText: PropTypes.string,
  /** Text to be displayed in modal sub-header */
  subHeadingText: PropTypes.string,
  /** Text to be displayed in modal body */
  bodyText: PropTypes.string,
  /** Function called by the parent when the modal is closed */
  onClose: PropTypes.func,
};

export default function CircleAnnouncement(props) {
  return (
    <article className={'circle-announcement-modal'}>
      {props.swoopArrow && props.swoopArrow}
      <div className={'circle-announcement-text-box' + (props.allignment ? ' ' + props.allignment : '')}>
        <h1 className='circle-announcement-text-box__heading'>{props.headingText}</h1>
        <p className='circle-announcement-text-box__body'>{props.bodyText}</p>
        {props.buttonText && <div className={'got-it-button' + (props.allignment ? ' ' + props.allignment : '')} onClick={props.onClose ? props.onClose : null}>{props.buttonText}
        </div>}
      </div>
    </article>  
  );
}



// WEBPACK FOOTER //
// ./src/components/modals/CircleAnnouncement/index.js